import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import config from 'uplisting-frontend/config/environment';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import { AnalyticsEvents } from 'uplisting-frontend/services/analytics';
import {
  openPageWithAmplitudeDeviceId,
  storeAmplitudeDeviceId,
} from 'uplisting-frontend/utils/analytics';

export default class SignupRoute extends BaseRoute {
  @service analytics!: Services['analytics'];

  queryParams = {
    i: {},
  };

  async beforeModel(transition: Transition): Promise<void> {
    if (this.session.isAuthenticated) {
      await this.router.transitionTo('index');
    } else {
      const url = new URL(config.auth.registerUrl);

      const invitationId = transition.to?.queryParams['i'] as
        | string
        | undefined;

      storeAmplitudeDeviceId(
        transition.to?.queryParams['amp_device_id'] as string | undefined,
      );

      if (invitationId) {
        url.searchParams.append('state', invitationId);
      }

      this.analytics.trackEvent(AnalyticsEvents.signupStarted, {
        invited: Boolean(invitationId),
      });

      openPageWithAmplitudeDeviceId(url.href);
    }
  }
}
